import { format } from 'date-fns'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { useAcknowledgeReturnReceiptRemindersMutation } from '../../../api/services/filesApi'
import NewModal from '../../root/modals/NewModal'
import NewTable from '../../table/NewTable'
import { Button } from '../../root/Button'

const ReturnReceiptReminderModal = ({ open, setOpen, data, requireAcknowledge = false }) => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const [acknowledgeReminders, { isLoading }] = useAcknowledgeReturnReceiptRemindersMutation()

  const dataForTable = useMemo(() => (Array.isArray(data) ? data : []), [data])

  const handleAcknowledge = async () => {
    if (dataForTable.length === 0) return

    const fileIds = dataForTable.map((item) => item.id)
    await acknowledgeReminders(fileIds).unwrap()
    setOpen(false)
  }

  const handleClose = () => setOpen(false)

  const columns = useMemo(
    () => [
      {
        Header: t('stamp_key'),
        accessor: 'Sifra',
      },
      {
        Header: t('client'),
        accessor: 'Klijent',
      },
      {
        Header: t('protocol_date'),
        accessor: 'createdAt',
        Cell: ({ value }) => (value ? format(new Date(value), 'dd.MM.yyyy') : ''),
      },
      {
        Header: t('return_receipt_days_overdue'),
        accessor: 'daysOverdue',
      },
      {
        Header: t('actions'),
        accessor: 'actions',
        disableSortBy: true,
        Cell: ({ row }) => (
          <Button
            white
            onClick={() => {
              setOpen(false)
              navigate(`/protocolbook/attachments/${row.original.id}`)
            }}
          >
            {t('open_protocol')}
          </Button>
        ),
      },
    ],
    [navigate, setOpen, t],
  )

  return (
    <NewModal
      title={t('return_receipt_overdue_title')}
      showModal={open}
      setShowModal={handleClose}
      page="Table"
      btns
      hideClose
      titleClose={requireAcknowledge ? undefined : t('close')}
      onClickClose={requireAcknowledge ? undefined : handleClose}
      titleSubmit={requireAcknowledge ? t('return_receipt_acknowledge') : undefined}
      onClickSubmit={requireAcknowledge ? handleAcknowledge : undefined}
      isLoading={isLoading}
      disableSubmit={dataForTable.length === 0}
    >
      <NewTable columns={columns} data={dataForTable} actions={false} pagination={false} />
    </NewModal>
  )
}

export default ReturnReceiptReminderModal
